import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../../../../store/app'
import { useDispatch, useSelector } from 'react-redux'
import { ViewIntersetExam, finishExam, submitAnswer, tierOneSubmitAnswer, setGoSkillModal, setUserSpecialFlag } from '../Utils/slice'
import { useNavigate, useParams } from 'react-router-dom'
import InterestAssessmentForm from './InterestAssessmentCommon/InterestAssessmentForm'
import { Form } from 'antd'
import PageSpinner from '../../../../../components/PageSpinner/PageSpinner'
import dayjs from 'dayjs'
import { setUserOptions } from '../../../../../store/AuthSlice'
import { setShowIntrestPopup } from '../../../../../store/CommonSlice'
import { get_users_industry } from '../../../../../config/Global'

/**
 * Renders the component for pending Interest Discovery Exam.
 *
 * @return {JSX.Element} The rendered component.
 */
const InterestAssessmentPending = () => {
    const dispatch: AppDispatch = useDispatch()
    const { id }: any = useParams()
    const allsteps = useSelector((state: RootState) => state.WEBPROFILE.bothExamData)
    const userDetail = useSelector((state: RootState) => state.AUTH.userDetail)

    const [current, setCurrent] = useState(Number(0));
    const [form] = Form.useForm();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const [btnLoading, setBtnLoading] = useState(false)
    const [updateSteps, setUpdateSteps] = useState<any>([])
    const [IntersetExamRecords, setIntersetExamRecords] = useState<any>(null);
    const decodedDataId = atob(id);

    const [generalQuestionLimit, setGeneralQuestion] = useState<any>(36);
    const [tierOneLimit, setTierOneLimit] = useState<any>(14);
    const [itemsPerPage, setItemsPerPage] = useState<any>(6);

    const totalQuestionLimit = generalQuestionLimit + tierOneLimit;
    const { is_solar } = get_users_industry(userDetail);

    // Set the answer of answered questions in the exam and to set remaining questions in the exam
    useEffect(() => {
        dispatch(setUserOptions()).then((res: any) => {
            // if (is_solar) {
            //     setGeneralQuestion(40)
            //     setTierOneLimit(8)
            //     setItemsPerPage(5)
            // }
            if (res?.user) {
                const userMeInfo = res.user;
                setGeneralQuestion(Number(userMeInfo?.industry?.general_questions_count));
                setTierOneLimit(Number(userMeInfo?.industry?.tier_one_questions_count));
                setItemsPerPage(11);
                dispatch(ViewIntersetExam(decodedDataId))
                    .then((data: any) => {
                        if (data.data.exam_status == 4) {
                            navigate('/interest-assessment-exam/' + id);
                            return 0;
                        }
                        setIntersetExamRecords(data?.data);




                    })
                    .catch((e: any) => e)

            }
        }).catch((e: any) => e)

    }, [])

    useEffect(() => {
        if (IntersetExamRecords != null) {
            console.log('tier1', IntersetExamRecords, generalQuestionLimit);
            if (IntersetExamRecords?.attends?.length > 0) {
                const questions = IntersetExamRecords.questions
                const attendsQue = IntersetExamRecords.attends
                const findWithoutAnswer = questions?.filter((item: any) => !attendsQue.some((item2: any) => item.id === item2.question_id));
                const findIndex = questions?.findIndex((item: any) => item?.id === findWithoutAnswer?.[0]?.id)
                setCurrent(findIndex)
            }
            if (IntersetExamRecords.attends) {
                IntersetExamRecords.attends.map((item: any) => form.setFieldValue(item.question_id, item?.answer))
            }
            if (IntersetExamRecords?.questions?.length > generalQuestionLimit) {


                setTierOneLimit(IntersetExamRecords?.questions?.length - generalQuestionLimit);


                var newArray: any = []

                const firstThirtySix = IntersetExamRecords?.questions?.slice(0, generalQuestionLimit).map((item: any) => ({
                    key: item?.id,
                    title: item?.question,
                    content: item?.answers,
                    question_id: item?.id,
                    options: item?.answer_options,
                    disabled: true
                }));


                const lastFourteen = IntersetExamRecords?.questions?.slice(generalQuestionLimit).map((item: any) => ({
                    key: item?.id,
                    title: item?.question,
                    content: item?.answers,
                    question_id: item?.id,
                    options: item?.answer_options,
                    disabled: false
                }));

                newArray.push([...firstThirtySix, ...lastFourteen])

                const steps = newArray[0].map((item: any, index: number) => ({
                    key: item?.key,
                    title: item?.title,
                    content: item?.content,
                    question_id: item?.question_id,
                    options: item?.options,
                    index: index + 1,
                    disabled: item.disabled
                }));
                setUpdateSteps(steps)
            } else {
                const steps = IntersetExamRecords?.questions?.map((item: any, index: number) => ({
                    key: item?.id,
                    title: item?.question,
                    content: item?.answers,
                    question_id: item?.id,
                    options: item?.answer_options,
                    index: index + 1,
                    disabled: true
                }));
                setUpdateSteps(steps)
            }
            setLoading(false)
        }

    }, [IntersetExamRecords, generalQuestionLimit]);



    // const itemsPerPage = 6;
    const startIndex = current;
    const endIndex = current + itemsPerPage;
    const getFirstSix = updateSteps?.length > 0 && updateSteps?.slice(startIndex, endIndex);

    console.log('getFirstSix', getFirstSix, allsteps?.attends?.length)
    const lastArrayData = getFirstSix && getFirstSix[getFirstSix?.length - 1]




    const validateForm = () => {
        form.validateFields()
    };

    // Button to move to next page and fetch remaining questions after 36 questions
    const nextButton = (data: any) => {
        const newArray = [];
        console.log('current', current, itemsPerPage)
        // Iterate over the key-value pairs and push them into the new array
        for (const [ques_id, ans_id] of Object.entries(data)) {
            newArray.push({ ques_id, ans_id });
        }
        data.answers = newArray
        data.assessment_type = "2"
        const keysToRemove = getFirstSix.map((item: any) => item.question_id);
        keysToRemove.forEach((key: any) => {
            delete data[key];
            return data
        });
        setBtnLoading(true)

        if (lastArrayData?.index === totalQuestionLimit) {
            completeExam(data)
        } else if (updateSteps.length > generalQuestionLimit && lastArrayData.disabled) {
            setBtnLoading(false)
            setCurrent(current + itemsPerPage);
        } else {
            dispatch(submitAnswer(decodedDataId, data))
                .then(() => {
                    console.log('tier-one', 'all-step', allsteps?.attends?.length, 'genqlimit', generalQuestionLimit, 'lastarr', lastArrayData?.index, 'update', updateSteps.length, 'total', totalQuestionLimit)
                    if (allsteps?.attends?.length < generalQuestionLimit && lastArrayData?.index === generalQuestionLimit && updateSteps.length != totalQuestionLimit) {
                        dispatch(tierOneSubmitAnswer(decodedDataId)).then((res: any) => {
                            const steps = res?.data?.questions.map((item: any, index: number) => ({
                                key: item?.id,
                                title: item?.question,
                                content: item?.answers,
                                question_id: item?.id,
                                options: item?.answer_options,
                                index: lastArrayData.index + index + 1,
                                disabled: false
                            }));
                            setTierOneLimit(res?.data?.questions.length);
                            setUpdateSteps([...updateSteps, ...steps])
                            setCurrent(current + itemsPerPage); /* Comment this line if you want to add question on same page */
                            setBtnLoading(false)
                        })
                            .catch((e: any) => {
                                if (e.data && e.data?.exam_flag != undefined && e.data.exam_flag == true) {

                                    // var specialExamFlagRequest = {
                                    //     user_id: userDetail.id,
                                    //     flag: 0
                                    // }
                                    // specialExamFlagRequest.flag  = 1;


                                    dispatch(setGoSkillModal(true))
                                    navigate("/dashboard")
                                    // dispatch(setUserSpecialExamFlag(specialExamFlagRequest)).then(() => {
                                    // });
                                    //     if(is_solar)
                                    //    {
                                    //     }
                                    //     else
                                    //    {
                                    //         dispatch(setShowIntrestPopup(true));
                                    //         navigate("/dashboard")
                                    //     }
                                }
                                else {
                                    navigate("/dashboard")
                                }
                            })
                    } else {


                        if (userDetail?.exam_flag == 1) {
                            var specialExamFlagRequest = {
                                user_id: userDetail.id,
                                flag: 0,
                                type: 1
                            }
                            dispatch(setUserSpecialFlag(specialExamFlagRequest))
                            dispatch(setUserOptions());
                        }
                        // dispatch(setUserSpecialExamFlag(specialExamFlagRequest));

                        setCurrent(current + itemsPerPage);
                        setBtnLoading(false)
                    }

                })
                .catch((e: any) => {
                    e
                    setBtnLoading(false)
                })
        }

    }

    // For scroll to the top after clicking on next button
    useEffect(() => {
        if (!btnLoading) {
            if ((document.body.clientHeight - 4) > window.innerHeight) {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        }
    }, [nextButton, btnLoading])

    // For submitting the exam after all the questions are answered
    const completeExam = (data: any) => {
        data.current_time = dayjs().format('YYYY-MM-DD HH:mm:ss'),
            dispatch(submitAnswer(decodedDataId, data)).then(() => {
                dispatch(finishExam(decodedDataId, data)).then(() => {
                    navigate("/dashboard")
                })
                    .catch((e: any) => {
                        e
                        navigate("/dashboard")
                        setBtnLoading(false)
                    })
            }).catch((e: any) => {
                e
                setBtnLoading(false)
            })

    }

    return !loading ? (
        <>
            <InterestAssessmentForm
                validateForm={validateForm}
                steps={updateSteps}
                nextButton={nextButton}
                form={form}
                current={current}
                setCurrent={setCurrent}
                id="InterestAssessmentFormPending"
                getFirstSix={getFirstSix}
                lastArrayData={lastArrayData}
                btnLoading={btnLoading}
                generalQuestionsLimit={generalQuestionLimit}
                tier1QuestionsLimit={tierOneLimit}
                industry_id={userDetail?.industry_id}
                itemsPerPage={itemsPerPage}

            />
        </>
    ) : <PageSpinner />
}

export default InterestAssessmentPending